<div class="row" style="border: 1px solid #d0d0ce;margin-left: 10px;margin-right:439px;height: 32px;">
<table>
    <td>
        <img style="width: 4%;margin-right: 12px;margin-left: 25px;" src="../../../../assets/images/Capture1.PNG">
    
  <span style="margin-right: 12px;">  Created</span>
<img src="../../../../assets/images/arrow-right.svg" style="width: 2%;margin-right: 12px;">
<img style="width: 4%; margin-right: 6px;margin-left: 0px" src="../../../../assets/images/Capture1.PNG">
<span style="margin-right: 12px;"> LA approved 1</span>
<img src="../../../../assets/images/arrow-right.svg" style="width: 2%;margin-right: 12px;">
<img style="width: 4%; margin-right: 6px;margin-left: 0px" src="../../../../assets/images/Capture1.PNG">
<span style="margin-right: 12px;"> LA approved 2</span>
<img src="../../../../assets/images/arrow-right.svg" style="width: 2%;margin-right: 12px;">
<img style="width: 4%; margin-right: 6px;margin-left: 0px" src="../../../../assets/images/Capture1.PNG">
<span style="margin-right: 12px;"> Supervisor approved</span>
<img src="../../../../assets/images/arrow-right.svg" style="width: 2%;margin-right: 12px;">
<img style="width: 4%; margin-right: 6px;margin-left: 0px" src="../../../../assets/images/Capture1.PNG">
<span style="margin-right: 12px"> Pass printed</span>
<img src="../../../../assets/images/arrow-right.svg" style="width: 2%;margin-right: 12px;">
<img style="width: 4%; margin-right: 6px;margin-left: 0px" src="../../../../assets/images/Capture1.PNG">
<span style="margin-right: 12px;font-weight: bolder;"> Received</span>

</td>
</table>
</div>
